<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/weather.png" alt="">
                        </div>

                        <h4>Weather</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <label >Area</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.area"-->
<!--                            :error="!data.area"-->
<!--                            :error-messages="!data.area? 'Area is Required':'' "-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.area" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Area is Required']">

                    </vTextareaAutocomplete>
                    <label >Image URL</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.imageUrl"-->
<!--                            :error="!data.imageUrl || !common.validURL(data.imageUrl)"-->
<!--                            :error-messages="!data.imageUrl? 'URL is Required':'' || !common.validURL(data.imageUrl)? 'URL is not valid':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.imageUrl" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'URL is Required']">

                    </vTextareaAutocomplete>
                    <v-layout row>
                        <v-flex xs4 class="pl-0">
                            <label >Temperature</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.temp"-->
<!--                                    :error="!data.temp"-->
<!--                                    :error-messages="!data.temp? 'Temperature is Required':'' "-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.temp" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Temperature is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex xs4>
                            <label >High temperature</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.hiTemp"-->
<!--                                    :error="!data.hiTemp"-->
<!--                                    :error-messages="!data.hiTemp? 'High temperature is Required':'' "-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.hiTemp" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'High temperature is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex xs4 class="pr-0">
                            <label >Low temperature </label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.lowTemp"-->
<!--                                    :error="!data.lowTemp"-->
<!--                                    :error-messages="!data.lowTemp? 'Low temperature is Required':'' "-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.lowTemp" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Low temperature is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import buttonsList from './common-inner-blocks/button-list'
    import common from "../../../../utils/common";
    import VueTribute from 'vue-tribute'
    import Tribute from "tributejs";
    export default {
        name: "text-block",
        components: {
            buttonsList,
            VueTribute
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common

            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>